import * as React from 'react';
import { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import NavBar from './NavBar/NavBar';
import AppRoutes from './SideBar/AppRoutes';
import ChatBubble from '../messaging/ChatBubble';
import { useAuth } from '../../context/AuthContext';
import { axiosClient } from '../../services/axiosClient';

function Dashboard() {
  const { user } = useAuth();
  const location = useLocation();
  const [checked, setChecked] = useState(false);
  const [hasActiveSub, setHasActiveSub] = useState(true);
  const [subscriptionFeatures, setSubscriptionFeatures] = useState({});

  useEffect(() => {
    let cancelled = false;
    const run = async () => {
      if (!user || user.role !== 'professional_responsable') { if (!cancelled) setChecked(true); return; }
      const path = location?.pathname || '';
      if (path.startsWith('/pro/subscribe')) { if (!cancelled) setChecked(true); return; }
      try {
        const res = await axiosClient.get('/subscriptions/my/');
        if (!cancelled) {
          setHasActiveSub(!!res?.data?.has_active);
          setSubscriptionFeatures(res?.data?.features || {});
          setChecked(true);
        }
      } catch (e) {
        if (!cancelled) { setHasActiveSub(false); setChecked(true); }
      }
    };
    run();
    return () => { cancelled = true; };
  }, [user, location]);

  if (!checked) return null;
  if (user && user.role === 'professional_responsable' && !hasActiveSub && !location.pathname.startsWith('/pro/subscribe')) {
    return <Navigate to="/pro/subscribe" replace />;
  }

  return (
    <NavBar>
      <AppRoutes />
      <ChatBubble subscriptionFeatures={subscriptionFeatures} />
    </NavBar>
  );
}

export default Dashboard;
